// Os produtos que a rodada está pagando, no formato de `POST /api/coupons/validate`.
//
// Achado 412 (04/10/2026): no Fechar mesa e no Finalizar da retirada a tela
// validava o cupom só pelo valor da rodada, e o desconto incidia também no
// produto em promoção que não aceita cupom. Agora a tela manda os produtos da
// rodada com o VALOR que entra agora de cada um, e quem decide a conta é o
// servidor — a mesma regra do pedido (`backend/api/v1/coupons/base.py`).
//
// Quando a rodada cobra menos que a soma dos produtos (uma parte já foi paga
// "por valor", sem produto marcado), cada produto entra na mesma proporção.
import { restanteItem, valorSelecionado } from "./divisao";

const centavos = (v) => Math.round((Number(v) || 0) * 100);

export function itensDaRodada(itens, { subtotal, selecionando } = {}) {
  const abertos = (itens || []).filter((i) => !i._paid);
  const marcados = abertos.filter((i) => i._selected && valorSelecionado(i) > 0);
  const usarMarcados = selecionando ?? marcados.length > 0;
  const pares = usarMarcados && marcados.length
    ? marcados.map((i) => [i, valorSelecionado(i)])
    : abertos.map((i) => [i, restanteItem(i)]);
  const soma = pares.reduce((s, [, v]) => s + v, 0);
  if (!(soma > 0)) return [];
  const teto = Number(subtotal);
  const fator = teto > 0 && teto < soma - 0.005 ? teto / soma : 1;
  return pares
    .filter(([, v]) => v > 0)
    .map(([i, v]) => ({
      id: i.product_id || i.id || null,
      nome: i.name || i.nome || "",
      preco: centavos(v * fator) / 100,
      quantidade: 1,
    }));
}

// Muda quando muda o que a rodada está pagando (para conferir o cupom de novo)
export const assinaturaDaRodada = (itens) => (itens || []).map((i) => `${i.id || i.nome}:${centavos(i.preco)}`).join(",");
